import { Board } from "../types";

const INITIAL_STATE = {
    boardReport: [],
    loading: false,
};

const boardReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case Board.SET_BOARD_REPORT:
            return {
                ...state,
                boardReport: action.payload,
            };
        default:
            return state;
    }
};

export default boardReducer;
